module.exports = __webpack_public_path__ + "static/media/pizzaPolloJamon.b6f56d16.jpg";